module.exports = __webpack_public_path__ + "81903718a72e1abee73620c31ebe7a4e.png";